import React from "react";
import CsvUploader from '../extra/CsvUploader'
import { useLocation, useNavigate } from "react-router-dom";
import { downloadCSV } from "../../libs/Libs";
import { BsFileEarmarkArrowDown } from "react-icons/bs";
import { Box, Container, Grid } from "@mui/material";
export default function ClientCsv() {
  const fields = [
    {
      name: "first_name",
      label: "First Name"
    },
    {
      name: "last_name",
      label: "Last Name"
    },
    {
      name: "country_code",
      label: "Phone Code"
    },
    {
      name: "phone",
      label: "Phone"
    },
    {
      name: "username",
      label: "Email"
    },
    {
      name: "group",
      label: "Main Role"
    },
    {
      name: "is_active",
      label: "Active"
    }
  ];
  // const fields = [
  //   {
  //     name: "event",
  //     label: "Event"
  //   },
  //   {
  //     name: "title",
  //     label: "Title"
  //   },
  //   {
  //     name: "message",
  //     label: "Message"
  //   },
  // ]
  return (
    <>
      <Container maxWidth="false" sx={{ mt: 2, width: "100%" }}>
        <Grid container>
          <Grid size={12}>
            <Box sx={{ display: "flex", justifyContent: "flex-end", px: 1, my: 2 }}>
              <button className="btn-primary pointer" onClick={() => downloadCSV(fields, 'message_import_template')}>
                <BsFileEarmarkArrowDown />  Download Template
              </button>
            </Box>
            <CsvUploader
              tableColumns={fields.map(f => f.name)}
              requiredFields={fields.map(f => f.name)}
              match_field="username"
              backUrl="users"
              model={'user'}
              onClose={() => { }} />
          </Grid>
        </Grid>
      </Container>
    </>
  )
}